import { z } from 'zod';
export type SignInReturnPath = '/account/contacts/verify' | `/incidents/${string}`;
/**
Never forward capabilities, result selectors, query strings or fragments into identity navigation.
*/
export function safeSignInReturnPath(value: string | null): SignInReturnPath | null {
  if (value === '/account/contacts/verify') return value;
  return value?.startsWith('/incidents/') &&
    z.uuid().safeParse(value.slice('/incidents/'.length)).success
    ? (value as `/incidents/${string}`)
    : null;
}
